module.exports = __webpack_public_path__ + "media/images/question_square-54e95d06579ad46fdd5ea470cf25228d.svg";